class Validate {
    validIfValueNotANull(value) {
        return !!value;
    }
    matchEmails(email, remail) {
        return email === remail;
    }
    validPhone(phoneNumber) {
        if (phoneNumber.length < 7 && phoneNumber.length > 10) {
            return false;
        }
        const reg = new RegExp("^0[0-9]{1}([0-9]{1})[0-9]{7}$");
        return reg.test(phoneNumber);
    }
    matchEmail(email) {
        const reg = new RegExp("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$");
        return reg.test(email);
    }
    validObject(obj, keysList = []) {
        if (keysList.length > 0) {
            for (let i = 0; i < keysList.length; i++) {
                if (obj[keysList[i]] === undefined || (Array.isArray(obj[keysList[i]]) && obj[keysList[i]].length === 0) || obj[keysList[i]] === null) {
                    return false;
                }
            }
            return true;
        }
        const keys = Object.keys(obj)
        if (keys.length === 0) {
            return false
        }
        for (let i = 0; i < keys.length; i++) {
            if (!obj[keys[i]]) {
                return false;
            }
        }
        return true;
    }
    isEqualDates(dateOne, dateTwo) {
        if (!(dateOne instanceof Date && dateTwo instanceof Date)) {
            return false;
        }
        return dateOne.getMonth() === dateTwo.getMonth() && dateOne.getDate() === dateTwo.getDate() && dateOne.getFullYear() === dateTwo.getFullYear();
    }
    isObjectsAreEqual(obj1,obj2,values=[]){
        for(let i =0;i<values.length;i++){
            if(obj1[values[i]] !== obj2[values[i]]){
                return false;
            }
        }
        return true;
    }
}
const validate = new Validate()
export default validate;